import {
  CannedJobExpanded,
  LaborMatrixEntry,
  PartsMatrixEntry
} from '../../sdk'
import {
  calcPriceWithMargin,
  filterMarginsFromAllMatrixEntries
} from '../handleMargins/handleMargins'

export function getCannedJobTotal(
  job: CannedJobExpanded,
  laborMatrixEntries: LaborMatrixEntry[],
  partsMatrixEntries: PartsMatrixEntry[]
) {
  const result = 'TBD'
  if (
    job.motorLabor!.length +
      job.partLookups!.length +
      job.inventoryParts!.length >
    0
  ) {
    return result
  }
  let total = 0
  for (const fluid of job.motorFluids!) {
    const price = fluid.info!.suggestedPricePerUnit
    const quantity = fluid.info!.suggestedQuantity
    if (price === undefined || quantity === undefined) {
      return result
    }
    total += price * quantity
  }
  for (const labor of job.customLabor!) {
    const price = labor.info!.hourlyRate
    const quantity = labor.info!.numHours
    const matrix = labor.info!.laborMatrix
    if (price !== undefined && quantity !== undefined) {
      total += price * quantity
    } else if (matrix !== undefined && quantity !== undefined) {
      const found = laborMatrixEntries.find((option) => option.id === matrix)
      const rate = found ? found.info!.hourlyRate! : 0
      total += rate * quantity
    } else {
      return result
    }
  }
  for (const part of job.customParts!) {
    const price = part.info!.retailPricePerUnit
    const quantity = part.info!.quantity
    const cost = part.info!.costPerUnit
    const matrix = part.info!.partsMatrix
    const curTotal = getPartPrice(
      price,
      quantity,
      cost,
      matrix,
      partsMatrixEntries
    )
    if (curTotal === undefined) {
      return result
    } else {
      total += curTotal
    }
  }
  for (const product of job.inventoryProducts!) {
    const part = job.idToInventoryProducts![product.info!.inventoryProduct!]
    const price = part.info!.retailPricePerUnit
    const quantity = product.info!.quantity
    const cost = part.info!.costPerUnit
    const matrix = part.info!.partsMatrix
    const curTotal = getPartPrice(
      price,
      quantity,
      cost,
      matrix,
      partsMatrixEntries
    )
    if (curTotal === undefined) {
      return result
    } else {
      total += curTotal
    }
  }
  for (const fee of job.customFees!) {
    total += fee.info!.numDollars!
  }
  return total
}

function getPartPrice(
  price: number | undefined,
  quantity: number | undefined,
  cost: number | undefined,
  matrix: string | undefined,
  partsMatrixEntries: PartsMatrixEntry[]
) {
  if (price !== undefined && quantity !== undefined) {
    return price * quantity
  } else if (
    matrix !== undefined &&
    quantity !== undefined &&
    cost !== undefined
  ) {
    return calcPriceWithMargin(
      cost,
      filterMarginsFromAllMatrixEntries(partsMatrixEntries, matrix, cost)
    )
  } else {
    return undefined
  }
}
